import React, {useEffect, useState} from 'react'
import {
    ChevronRightIcon,
    ArrowDownOnSquareIcon,
    ArrowUpOnSquareIcon,
    XMarkIcon,
    CheckCircleIcon
} from "@heroicons/react/24/solid";
import {
    DEFAULT_SHOPIFY_PRODUCT_IMAGE_TAB, DEFAULT_SHOPIFY_PRODUCT_IMAGE_TYPE_TAB,
    DOWNLOAD_IMAGE_TIME_DELAY, INSTAGRAM_IMAGE_SIZE_1_TO_1,
    INSTAGRAM_IMAGE_SIZE_4_TO_5,
    INSTAGRAM_POST_FIELDS,
    LOGO_FIELD_LIST,
    LOGO_IMAGE_DETAIL,
    PRODUCT_IMAGE_DETAIL,
    PRODUCT_IMAGE_FIELD_LIST,
    SAVE_PRODUCT_TIME_DELAY,
    SHOPIFY_PRODUCT_IMAGE_TABS_LIST,
    SHOPIFY_PRODUCT_IMAGE_TYPE_TABS_LIST,
    UPLOAD_IMAGE_TIME_DELAY,
} from "../../constants/shopify.constant";
import ShowProductDetail from "./show-product-detail";
import DesignInstagramProductImage from "./design-instagram-product-image";
import SelectColorTypeDetails from "../../../design/components/design-editor/settings/select-color-type-details";
import _ from "lodash";
import Promise from "bluebird";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import {getSingleShopifyProduct, updateSingleShopifyProduct} from "../../services/shopify-product-data-service";
import {
    getSingleDesignVariant,
    getSingleDesignVariantDetail
} from "../../../design/services/design-variant-data-service";
import CopyDataToClipboard from "../../../common/ui/copy-data-to-clipboard";
import {appConfig, firebaseStorage, storageRef} from "../../../firebase/client-app";
import RenderFields from "../../../common/ui/render-fields";
import {processLogoDetails} from "../../utils/logo-util";
import {applyProductImageSettings, getImageContainer} from "../../utils/product-image-util";
import ShowTabsList from "../../../common/ui/show-tabs-list";
import "react-datepicker/dist/react-datepicker.css";
import {getDownloadURL} from "@firebase/storage";
import {prepareProductInstagramPost} from "../../../social/instagram/instagram-shopify-product-util";
import {createInstagramCarousalPost} from "../../../social/instagram/instagram-api-service";
import ShowAddProductToShopify from "./show-add-shopify-product";
import {updateSingleDesign} from "../../../design/services/design-data-service";

const defaultSettings: any = {
    background: {
        colorType: "solid",
        backgroundColorKey: "gray",
        backgroundColor: "#1F2937",
        backgroundColorCodeKey: "800"
    },
    ...INSTAGRAM_IMAGE_SIZE_1_TO_1,
    ...LOGO_IMAGE_DETAIL,
    ...PRODUCT_IMAGE_DETAIL,
    instagramText: '',
}

const tabsList = SHOPIFY_PRODUCT_IMAGE_TABS_LIST;
const imageTabsList = SHOPIFY_PRODUCT_IMAGE_TYPE_TABS_LIST;

const ShowProductImages = ({
                               product,
                               productIndex = 0,
                               setSelectedProduct,
                               setProductDetailInList,
                               isLightButton = true,
                               selectedDesign = null,
                               setSelectedDesign = null
                           }) => {
    const [productDetail, setProductDetail] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [downloadAllImages, setDownloadAllImages] = useState(false);
    const [uploadAllImages, setUploadAllImages] = useState(false);
    const [publishInstagramInProgress, setPublishInstagramInProgress] = useState(false);
    const [selectedProductImage, setSelectedProductImage] = useState(null);
    let [changesCount, setChangesCount] = useState(0);
    const [selectedVariant, setSelectedVariant] = useState(null);
    // const [instagramText, setInstagramText] = useState(null);
    const [selectedTab, setSelectedTab] = useState(DEFAULT_SHOPIFY_PRODUCT_IMAGE_TAB);
    const [selectedImageTab, setSelectedImageTab] = useState(DEFAULT_SHOPIFY_PRODUCT_IMAGE_TYPE_TAB);

    useEffect(() => {
        if (showModal) {
            handleImageTabChanges();
        }
    }, [selectedImageTab]);

    const handleImageTabChanges = () => {
        const existingProductDetail = {...productDetail};
        const existingSettings = existingProductDetail.settings || _.cloneDeep(defaultSettings);
        const imageContainer = getImageContainer(selectedImageTab?.key);

        if (!_.isEmpty(imageContainer)) {
            existingSettings.width = imageContainer.width;
            existingSettings.height = imageContainer.height;
        }

        applyProductImageSettings(existingSettings, productDetail);

        existingProductDetail.settings = existingSettings;
        prepareInstagramText(existingProductDetail);
        setProductDetail(existingProductDetail);

        setProductDetailInList(existingProductDetail);
    }

    const handleCloseAction = () => {
        setDownloadAllImages(false);
        setShowModal(false);
    }

    const handleSettingsChanges = (event, childProperty) => {
        const {name, value, type} = event.target;
        const existingProductDetail = {...productDetail};
        // const existingSettings = existingProductDetail.settings || defaultSettings;
        const existingSettings = existingProductDetail.settings || _.cloneDeep(defaultSettings);

        if (_.isEmpty(existingSettings?.logo)) {
            existingSettings.logo = LOGO_IMAGE_DETAIL.logo;
        }

        if (_.isEmpty(existingSettings?.product)) {
            existingSettings.product = PRODUCT_IMAGE_DETAIL.product;
        }

        if (childProperty === 'product') {
            const productConfig = existingSettings.product;
            if (type === 'checkbox') {
                productConfig[name] = !productConfig[name];
            } else if (type === 'number') {
                productConfig[name] = _.parseInt(value);
            } else {
                productConfig[name] = value;
            }

            existingSettings.product = productConfig;
            applyProductImageSettings(existingSettings, productDetail);
        } else {
            if (type === 'checkbox') {
                existingSettings[name] = !existingSettings[name];
            } else {
                existingSettings[name] = value;
            }

            if (name === 'positionType') {
                processLogoDetails(existingSettings);
            }
        }

        existingProductDetail.settings = existingSettings;
        prepareInstagramText(existingProductDetail);
        setProductDetail(existingProductDetail);

        setProductDetailInList(existingProductDetail);
    }

    const updateSettingsInDesign = async () => {
        const existingProductDetail = {...productDetail};
        selectedDesign.shopifySettings = existingProductDetail.settings;
        delete selectedDesign.shopifySettings.imagesUploaded;

        setSelectedDesign(selectedDesign);
        await updateSingleDesign(selectedDesign);
    }

    const useDesignSettings = async () => {
        const existingProductDetail = {...productDetail};
        const existingSelectedDesign = {...selectedDesign};
        existingProductDetail.settings = existingSelectedDesign.shopifySettings;
        setProductDetail(existingProductDetail);
        setProductDetailInList(existingProductDetail);
    }

    const handleClearColorInSettings = (attributeList) => {
        const existingProductDetail = {...productDetail};
        const existingSettings = existingProductDetail.settings || defaultSettings;

        _.forEach(attributeList, attribute => {
            existingSettings[attribute] = '';
        });

        existingProductDetail.settings = existingSettings;
        setProductDetail(existingProductDetail);

        setProductDetailInList(existingProductDetail);
    }

    const getProductById = async (selectedProduct) => {
        if (selectedProduct && selectedProduct?.id) {
            setSelectedProduct(selectedProduct);
            const productData = await getSingleShopifyProduct(selectedProduct?.id);
            initSettings(productData);
            await getDesignVariantById();
            incrementChangesCount();
        }
    }

    const getDesignVariantById = async () => {
        if (product && product?.designVariantId) {
            const designVariantDetail = await getSingleDesignVariantDetail(product?.designVariantId)
            setSelectedVariant(designVariantDetail);
        }
    }

    const initSettings = (productData) => {
        const existingProduct = productData;

        if (existingProduct && _.isEmpty(existingProduct?.settings)) {
            existingProduct.settings = selectedDesign.shopifySettings || defaultSettings;
            existingProduct.settings.imagesUploaded = false;
            existingProduct.settings.postDate = '';
            // existingProduct.settings.postTime = '';
            existingProduct.settings.status = '';
            // existingProduct.settings = _.cloneDeep(defaultSettings);
        }

        if (_.isEmpty(existingProduct?.settings?.logo)) {
            existingProduct.settings.logo = LOGO_IMAGE_DETAIL.logo;
        }

        if (_.isEmpty(existingProduct?.settings?.product)) {
            existingProduct.settings.product = PRODUCT_IMAGE_DETAIL.product;
        }

        applyProductImageSettings(existingProduct.settings, existingProduct);
        prepareInstagramText(existingProduct);
        setProductDetail(existingProduct);
        setProductDetailInList(existingProduct);
    }

    useEffect(() => {
        if (showModal) {
            getProductById(product);
            setSelectedImageTab(DEFAULT_SHOPIFY_PRODUCT_IMAGE_TYPE_TAB);
        }
    }, [showModal]);

    useEffect(() => {
        incrementChangesCount();
    }, [productDetail]);

    useEffect(() => {
        if (selectedVariant) {
            const existingProductDetail = {...productDetail};
            if (existingProductDetail) {
                prepareInstagramText(existingProductDetail);
                setProductDetail(existingProductDetail);
            }
        }
    }, [selectedVariant]);

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {

                if (changesCount > 0) {
                    resetChangesCount();
                    saveProductChanges();
                }

            }, SAVE_PRODUCT_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    }, [changesCount]);

    const saveProductChanges = async () => {
        const existingProductDetail = {...productDetail};

        if (!_.isEmpty(existingProductDetail)) {
            await updateSingleShopifyProduct(existingProductDetail);
            // setProductDetailInList(existingProductDetail);
        }
    }

    const incrementChangesCount = () => {
        setChangesCount(++changesCount);
    }

    const resetChangesCount = () => {
        setChangesCount(0);
    }

    const setProductImageDetail = (event, productImage) => {
        const {name, value, type} = event.target;
        const existingProductDetail = {...productDetail};
        const existingImages = existingProductDetail.images;

        const productImageIndex = _.findIndex(existingImages, ['id', productImage.id]);

        if (type === 'checkbox') {
            existingImages[productImageIndex][name] = !existingImages[productImageIndex][name];
        } else {
            existingImages[productImageIndex][name] = value;
        }

        existingProductDetail.images = existingImages;
        setProductDetail(existingProductDetail);
    }

    useEffect(() => {
        const timeoutId =
            setTimeout(async () => {
                if (showModal && (downloadAllImages || uploadAllImages)) {
                    processUploadOrDownloadImages();
                }

            }, DOWNLOAD_IMAGE_TIME_DELAY);

        return () => clearTimeout(timeoutId);
    });

    const processUploadOrDownloadImages = async () => {
        let nextIndex = 0;
        let existingProductDetail = {...productDetail};
        let existingCurrentProductImage = {...selectedProductImage};

        if (existingCurrentProductImage) {
            const currentIndex = _.findIndex(existingProductDetail?.images, ['id', existingCurrentProductImage.id]);
            nextIndex = currentIndex + 1;
        }

        if (existingProductDetail && existingProductDetail?.images?.hasOwnProperty(nextIndex)) {
            setSelectedProductImage(existingProductDetail?.images[nextIndex]);
        } else {
            if (uploadAllImages) {
                existingProductDetail.settings.imagesUploaded = true;
                existingProductDetail.imageFilesList = _.map(_.filter(existingProductDetail?.images, {instagram: true}), (productImage) => {
                    return {
                        imageFilePath: productImage.imageFilePath,
                    }
                });

                prepareInstagramText(existingProductDetail);
                setProductDetail(existingProductDetail);
                setProductDetailInList(existingProductDetail);
                setUploadAllImages(false);
                setSelectedProductImage(null);
                handleCloseAction();
            } else {
                setDownloadAllImages(false);
                setSelectedProductImage(null);
            }
        }
    }

    const prepareInstagramText = (existingProductDetail) => {
        if (selectedDesign) {
            let combinedInstagramText = '';
            const existingSelectedDesign = {...selectedDesign};

            if (existingSelectedDesign?.content?.contentList?.length > 0) {
                const contentList = existingSelectedDesign?.content?.contentList;
                if (contentList[productIndex]) {
                    // existingProductDetail.settings.instagramText = contentList[productIndex]?.facebookPost;
                    combinedInstagramText = contentList[productIndex]?.facebookPost + '\n\n';
                }
            }

            const existingSelectedVariant = {...selectedVariant};
            combinedInstagramText += existingProductDetail.title;
            combinedInstagramText += '\n\n' + existingProductDetail.onlineStoreUrl;

            if (appConfig.appSocialShareText) {
                combinedInstagramText += '\n\n' + appConfig.appSocialShareText;
            }

            const postContentHashTags = _.split(combinedInstagramText, '#');
            const allowedTagsCount = 29 - postContentHashTags.length;
            let allHashTagsList = [];
            let hashTags: any = [];

            if (existingSelectedVariant?.instagramTags) {
                hashTags = existingSelectedVariant?.instagramTags;
                allHashTagsList = _.split(hashTags, '#');
            } else if (existingSelectedDesign?.designTags) {
                hashTags = _.map(existingSelectedDesign?.designTags, (tag) => {
                    return '#' + _.upperFirst(_.camelCase(tag));
                });

                allHashTagsList = _.split(hashTags, '#');
            }

            if (allHashTagsList.length > 0) {
                if (allHashTagsList.length > allowedTagsCount) {
                    const allowedHashTagsList = _.chunk(allHashTagsList, allowedTagsCount);
                    hashTags = _.join(allowedHashTagsList[0], '#');
                }

                combinedInstagramText += '\n\n' + _.split(hashTags, ',').join(' ');
                // combinedInstagramText += '\n\n' + _.toLower(hashTags);
            }

            existingProductDetail.settings.instagramText = combinedInstagramText;
        }

        prepareInstagramPostStatus(existingProductDetail);
    }

    const prepareInstagramPostStatus = (existingProductDetail) => {
        existingProductDetail.instagramPost = prepareProductInstagramPost(existingProductDetail);

        if (existingProductDetail?.instagramPost && existingProductDetail.settings?.postDate && existingProductDetail.settings?.postTime) {
            if (!existingProductDetail?.instagramPost?.status || existingProductDetail?.instagramPost?.status !== 'Published') {
                existingProductDetail.instagramPost.status = 'Scheduled';
            }
        }
    }

    /*const publishInstagramPost = async () => {
        setPublishInstagramInProgress(true);
        const existingProductDetail = {...productDetail};
        existingProductDetail.instagramPost = prepareProductInstagramPost(existingProductDetail);

        await createInstagramCarousalPost(existingProductDetail.instagramPost);
        setProductDetail(existingProductDetail);
        setPublishInstagramInProgress(false);
    }

    const publishFacebookPost = async () => {
        setPublishInstagramInProgress(true);
        const existingProductDetail = {...productDetail};
        existingProductDetail.instagramPost = prepareProductInstagramPost(existingProductDetail);

        // await createInstagramCarousalPost(existingProductDetail.instagramPost);
        // setProductDetail(existingProductDetail);
        setPublishInstagramInProgress(false);
    }*/

    return (
        <>
            {product?.images?.length > 0 &&
                <div className="flex items-center justify-center w-36">
                    <button
                        className={`flex py-2 px-4 ${isLightButton ? 'button-outline-gray' : 'button-gray'}`}
                        onClick={() => setShowModal(true)}>
                        <span>Edit Images</span>
                    </button>
                </div>
            }

            {showModal && productDetail &&
                <>
                    <div
                        className="w-full h-full justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-x-0 top-0 z-50 outline-none focus:outline-none">
                        <div className="relative w-full h-full">
                            {/*content*/}
                            <div
                                className="border-0 shadow-lg relative flex flex-col w-full h-full bg-white outline-none focus:outline-none">
                                {/*header*/}
                                <div
                                    className="flex justify-between px-5 pt-4 rounded-t">
                                    <div className='flex justify-start w-4/5'>
                                        <h3 className="text-2xl font-bold ml-2 mr-4">Instagram Images</h3>
                                        <div className="flex flex-wrap justify-start">
                                            <ShowProductDetail product={productDetail}/>
                                        </div>
                                    </div>

                                    <div className="mr-2 w-3/5 flex flex-wrap justify-center items-center">
                                        <div className="mr-2">
                                            <ShowProgressSpinner
                                                dataFetchInProgress={downloadAllImages || uploadAllImages || publishInstagramInProgress}/>
                                        </div>

                                        <button onClick={() => {
                                            setUploadAllImages(true);
                                        }}
                                                className="button-green py-2 px-3 mx-1 my-1 flex justify-center">
                                            <div className="pr-2">
                                                <ArrowUpOnSquareIcon className="h-6 w-6"/>
                                            </div>
                                            Upload All ({productDetail?.images?.length})
                                        </button>

                                        <button onClick={() => {
                                            setDownloadAllImages(true);
                                        }}
                                                className="button-gray py-2 px-3 mx-1 my-1 flex justify-center">
                                            <div className="pr-2">
                                                <ArrowDownOnSquareIcon className="h-6 w-6"/>
                                            </div>
                                            Download All ({productDetail?.images?.length})
                                        </button>

                                        {/*<button onClick={publishInstagramPost}
                                                className="button-green py-2 px-3 mx-1 my-1 flex justify-center">
                                            Publish Instagram
                                        </button>

                                        <button onClick={publishFacebookPost}
                                                className="button-green py-2 px-3 mx-1 my-1 flex justify-center">
                                            Publish Facebook
                                        </button>*/}

                                        <ShowAddProductToShopify productDetail={product}/>
                                    </div>

                                    <div className="mr-2 flex justify-center items-center">
                                        <div className="">
                                            <button
                                                className="button-gray-outline px-3 py-2"
                                                onClick={handleCloseAction}>
                                                <div className="">
                                                    <XMarkIcon className="h-6 w-6"/>
                                                </div>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                <div
                                    className="relative px-6">

                                    <div className="flex justify-center pt-4 w-full">

                                        <div className="w-full">

                                            <div>
                                                <ShowTabsList
                                                    setSelectedTab={setSelectedImageTab}
                                                    selectedTab={selectedImageTab}
                                                    tabsList={imageTabsList}/>
                                            </div>

                                            {productDetail?.settings &&

                                                <div
                                                    className="instagram-image-designer-container overflow-y-scroll w-full border border-gray-300 rounded-b bg-gray-100 flex flex-wrap justify-start">

                                                    {productDetail?.images?.map((productImage, index) => (
                                                        <React.Fragment key={index}>

                                                            <DesignInstagramProductImage
                                                                settings={productDetail?.settings}
                                                                product={productDetail}
                                                                selectedImageTab={selectedImageTab}
                                                                selectedProductImage={selectedProductImage}
                                                                uploadAllImages={uploadAllImages}
                                                                productImage={productImage}
                                                                setProductImageDetail={setProductImageDetail}
                                                            />

                                                        </React.Fragment>
                                                    ))}

                                                </div>

                                            }

                                        </div>

                                        <div className="w-3/7 px-4">

                                            <div>
                                                <ShowTabsList
                                                    setSelectedTab={setSelectedTab}
                                                    selectedTab={selectedTab}
                                                    tabsList={tabsList}/>
                                            </div>

                                            {selectedTab?.key === 'settings' &&
                                                <div
                                                    className="instagram-image-settings-container overflow-y-scroll border border-gray-300 rounded-b bg-gray-100 mt-4 pt-4 px-4">
                                                    {productDetail?.settings &&
                                                        <>
                                                            <div className="flex flex-wrap justify-start mb-4 ml-2">
                                                                <button
                                                                    className={`py-2 px-4 button-outline-gray mr-2`}
                                                                    onClick={useDesignSettings}>
                                                                    <span>Use Design Settings</span>
                                                                </button>

                                                                <button
                                                                    className={`py-2 px-4 button-outline-green mr-2`}
                                                                    onClick={updateSettingsInDesign}>
                                                                    <span>Update Settings In Design</span>
                                                                </button>
                                                            </div>

                                                            <SelectColorTypeDetails
                                                                label={'Background Color & Shade'}
                                                                parentForm={productDetail?.settings?.background}
                                                                colorAttribute={'background'}
                                                                colorKeyAttribute={'backgroundColorKey'}
                                                                colorCodeKeyAttribute={'backgroundColorCodeKey'}
                                                                settings={productDetail?.settings}
                                                                handleColorDetailsChanges={handleSettingsChanges}
                                                                handleClearColorDetailsChanges={handleClearColorInSettings}/>

                                                            <div className="flex flex-wrap justify-start">
                                                                <RenderFields
                                                                    parentForm={productDetail?.settings}
                                                                    handleDetailChanges={handleSettingsChanges}
                                                                    fieldList={LOGO_FIELD_LIST}
                                                                    enableEdit={true}
                                                                    fieldClassName={'w-1/2'}/>
                                                            </div>

                                                            {productDetail?.settings?.product &&
                                                                <>
                                                                    <div className="ml-2 mt-2 field-label">
                                                                        Product Image
                                                                    </div>

                                                                    <div className="flex flex-wrap justify-start">
                                                                        <RenderFields
                                                                            parentForm={productDetail?.settings?.product}
                                                                            handleDetailChanges={(event) => {
                                                                                handleSettingsChanges(event, 'product');
                                                                            }}
                                                                            fieldList={_.groupBy(PRODUCT_IMAGE_FIELD_LIST, 'group')['dimension']}
                                                                            enableEdit={true}
                                                                            fieldClassName={'w-1/2'}/>
                                                                    </div>
                                                                </>
                                                            }
                                                        </>
                                                    }
                                                </div>
                                            }

                                            {selectedTab?.key === 'instagram' &&
                                                <div
                                                    className="instagram-image-settings-container overflow-y-scroll border border-gray-300 rounded-b bg-gray-100 mt-4 pt-4 px-4">

                                                    <div className="field-label-purple mt-1 ml-2">
                                                        Instagram Post
                                                    </div>

                                                    {/*{!productDetail?.settings?.imagesUploaded &&
                                                        <div
                                                            className="p-2 mx-2 mt-3 mb-2 bg-red-200 text-red-900 text-center border border-red-900 rounded">
                                                            Upload Instagram Images Before Scheduling Post
                                                        </div>
                                                    }*/}

                                                    {/*{productDetail?.settings?.imagesUploaded &&

                                                    }*/}

                                                    <>
                                                        <div className="flex flex-wrap justify-start">
                                                            <RenderFields
                                                                parentForm={productDetail?.settings}
                                                                handleDetailChanges={handleSettingsChanges}
                                                                fieldList={INSTAGRAM_POST_FIELDS}
                                                                enableEdit={true}
                                                                fieldClassName={'w-1/2'}/>
                                                        </div>

                                                        <div className="field-group-container mt-4">
                                                            <div className="field-container w-full">
                                                                <div className="flex justify-start items-center">
                                                                    <div className="field-label-purple mt-1">
                                                                        Instagram / Facebook Text
                                                                    </div>
                                                                    <div className="ml-2">
                                                                        <CopyDataToClipboard
                                                                            value={productDetail?.settings?.instagramText}/>
                                                                    </div>
                                                                </div>
                                                                <div className="mt-2">
                                                                        <textarea id="instagramText"
                                                                                  name="instagramText"
                                                                                  value={productDetail?.settings?.instagramText}
                                                                                  onChange={(event) => {
                                                                                      handleSettingsChanges(event, {})
                                                                                  }}
                                                                                  className="w-full h-96 border border-purple-500 p-4 rounded"/>
                                                                </div>
                                                            </div>

                                                            <div className="field-container w-full">
                                                                <div className="flex justify-start items-center">
                                                                    <div className="field-label mt-1">
                                                                        Instagram Tags
                                                                    </div>
                                                                    <div className="ml-2">
                                                                        <CopyDataToClipboard
                                                                            value={selectedVariant?.instagramTags}/>
                                                                    </div>
                                                                </div>
                                                                <div className="mt-2">
                                                                        <textarea id="instagramTags"
                                                                                  name="instagramTags"
                                                                                  disabled={true}
                                                                                  value={selectedVariant?.instagramTags}
                                                                                  className="w-full h-32 border border-gray-500 p-4 rounded"/>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </>

                                                </div>
                                            }

                                        </div>

                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
                </>
            }
        </>
    )
}

export default ShowProductImages
